// extracted by mini-css-extract-plugin
export default {"title":"Header_title__Fa0Z4","subTitleBlock":"Header_subTitleBlock__dLK9N","subTitle":"Header_subTitle__+Ln37","images":"Header_images__bHRCI"};